module.exports = __webpack_public_path__ + "static/apple-icon-114x114-b3df587ef5f398daf028c2c77e771801.png";